import { z } from "zod";

export type EvaluationJob = {
  job_id: string;
  job_name: string;
  user_id: string;
  num_questions: number;
  total_count: number;
  processed_count: number;
  failed_count: number;
  state: "init" | "processing" | "exporting" | "failed" | "finished";
  timestamp_start: string;
  timestamp_end: string;
  error: string;
};

export const questionSchema = z.object({
  question: z.string().min(1, "Question is required"),
  reference_answer: z.string().min(1, "Reference answer is required"),
  rubrics: z.string().min(1, "Rubrics are required"),
  marks: z.number().min(1, "Marks must be at least 1"),
});

export const setSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, "Name is required"),
  questions: z
    .array(questionSchema)
    .min(1, "At least one question is required"),
});

export type Question = z.infer<typeof questionSchema>;
export type QuestionSet = z.infer<typeof setSchema>;
